import MenuIcon from '@mui/icons-material/Menu';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React from 'react';
import { globalMenuWidthSmall } from '../../GlobalMenu/constants';
import { useCommonWebTranslation, useSmallDevice } from '../../hooks';
/**
 * Renders a responsive header menu component that displays a dropdown of navigation items.
 *
 * @param {HeaderMenuProps} props - Component properties.
 * @param {LandingPageHeaderItem[]} props.headerItems - An array of header menu items including labels, hrefs, and optional onClick handlers.
 * @returns {JSX.Element} The rendered header menu with toggleable dropdown items.
 */
export const HeaderMenu = (props) => {
    const { t } = useCommonWebTranslation();
    const smallDevice = useSmallDevice();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const openMenu = (event) => setAnchorEl(event.currentTarget);
    const closeMenu = () => setAnchorEl(null);
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { "aria-label": t('common.menu'), color: 'primary', onClick: openMenu },
            React.createElement(MenuIcon, null)),
        React.createElement(Menu, { anchorEl: anchorEl, anchorOrigin: { horizontal: smallDevice ? globalMenuWidthSmall - 4 : globalMenuWidthSmall - 8, vertical: 'bottom' }, transformOrigin: { horizontal: 'right', vertical: 'top' }, marginThreshold: 0, open: open, onClose: handleClose, slotProps: {
                paper: smallDevice
                    ? {
                        style: {
                            width: '100%',
                            maxWidth: '100%',
                        },
                    }
                    : undefined,
            } }, props.headerItems.map(({ label, href, onClick }) => {
            return href ? (React.createElement(MenuItem, { key: label, onClick: (event) => {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                    closeMenu();
                }, component: 'a', href: href }, label)) : (React.createElement(MenuItem, { key: label, onClick: (event) => {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                    closeMenu();
                } }, label));
        }))));
};
